export enum LimitDuration {
  _24Hours = 1,
  _1Week = 2,
  _1Month = 3,
  _3Months = 4,
  NoDuration = 5,
  Session = 6,
}
